import React from 'react';
import { observer } from 'mobx-react-lite';
import { gameConfigStore, userInfoStore } from '@pascal/pascal-core/shared/core/store';
import { useTranslation } from '@pascal/pascal-core';

const LIMITS_AND_PAYOUT_ODDS = {
  main: [
    {
      name: 'BLACKJACK',
      odd: '3 : 2',
    },
    {
      name: 'WIN',
      odd: '1 : 1',
    },
    {
      name: 'INSURANCE',
      odd: '2 : 1',
    },
    {
      name: 'SURRENDER',
      odd: '1 : 2',
    },
  ],
  side21plus3: [
    {
      name: 'FLUSH',
      odd: '5 : 1',
      colorClass: ['red', 'red', 'red'],
      card: ['Q', 'J', '3'],
      cardIcons: ['icon-diamond', 'icon-diamond', 'icon-diamond'],
    },
    {
      name: 'STRAIGHT',
      odd: '10 : 1',
      colorClass: ['red', 'red', 'black'],
      card: ['Q', 'J', '10'],
      cardIcons: ['icon-diamond', 'icon-heart', 'icon-spades'],
    },
    {
      name: 'THREE_OF_A_KIND',
      odd: '30 : 1',
      colorClass: ['red', 'black', 'red'],
      card: ['Q', 'Q', 'Q'],
      cardIcons: ['icon-diamond', 'icon-spades', 'icon-heart'],
    },
    {
      name: 'STRAIGHT_FLUSH',
      odd: '40 : 1',
      colorClass: ['red', 'red', 'red'],
      card: ['Q', 'J', '10'],
      cardIcons: ['icon-diamond', 'icon-diamond', 'icon-diamond'],
    },
    {
      name: 'SUITED_TRIPS',
      odd: '100 : 1',
      colorClass: ['red', 'red', 'red'],
      card: ['Q', 'Q', 'Q'],
      cardIcons: ['icon-diamond', 'icon-diamond', 'icon-diamond'],
    },
  ],
  sidePerfectPair: [
    {
      name: 'MIXED_PAIR',
      odd: '5 : 1',
      colorClass: ['black', 'red'],
      card: ['Q', 'Q'],
      cardIcons: ['icon-spades', 'icon-diamond'],
    },
    {
      name: 'COLORED_PAIR',
      odd: '12 : 1',
      colorClass: ['red', 'red'],
      card: ['Q', 'Q'],
      cardIcons: ['icon-diamond', 'icon-heart'],
    },
    {
      name: 'PERFECT_PAIR',
      odd: '25 : 1',
      colorClass: ['red', 'red'],
      card: ['Q', 'Q'],
      cardIcons: ['icon-diamond', 'icon-diamond'],
    },
  ],
};
const LimitAndPayouts = observer(() => {
  const { currencySymbolOrCode } = userInfoStore;
  const { limits } = gameConfigStore;
  const t = useTranslation();
  return (
    <div className='limit-payouts-holder'>
      <div className='tb-limit-payout-body'>
        <div className='limit-payouts-row head'>
          <span className='limit-payouts-column name'>{t('MAIN')}</span>
          <span className='limit-payouts-column number'>
            {currencySymbolOrCode} {limits.minBet}-{limits.maxBet}
          </span>
        </div>
        {LIMITS_AND_PAYOUT_ODDS.main.map(({ name, odd }) => (
          <div key={name} className='limit-payouts-row'>
            <div className='limit-payouts-column name'>{t(name)}</div>
            <div className='limit-payouts-column number'>{odd}</div>
          </div>
        ))}
        <div className='limit-payouts-row head'>
          <span className='limit-payouts-column name'>{t('SIDE_21_PLUS_3')}</span>
          <span className='limit-payouts-column number'>
            {currencySymbolOrCode} {limits.sideBetsLimits.side21plus3.minBet}-
            {limits.sideBetsLimits.side21plus3.maxBet}
          </span>
        </div>
        {LIMITS_AND_PAYOUT_ODDS.side21plus3.map(({ name, odd, colorClass, card, cardIcons }) => (
          <div key={name} className='limit-payouts-row'>
            <span className='limit-payouts-column name'>{t(name)}</span>
            <div className='limit-payouts-column-container'>
              <div className='results-fairness-check-column'>
                {card.map((item, index) => (
                  <div
                    key={item.concat(`${index}`)}
                    className={`results-fairness-check-cards ${colorClass[index]}`}
                  >
                    <span>{item}</span>
                    <i className={cardIcons[index]} />
                  </div>
                ))}
              </div>
              <span className='limit-payouts-column coefficient'>{odd}</span>
            </div>
          </div>
        ))}
        <div className='limit-payouts-row head'>
          <span className='limit-payouts-column name'>{t('PERFECT_PAIR')}</span>
          <span className='limit-payouts-column number'>
            {currencySymbolOrCode} {limits.sideBetsLimits.sidePerfectPair.minBet}-
            {limits.sideBetsLimits.sidePerfectPair.maxBet}
          </span>
        </div>
        {LIMITS_AND_PAYOUT_ODDS.sidePerfectPair.map(
          ({ name, odd, colorClass, card, cardIcons }) => (
            <div key={name} className='limit-payouts-row'>
              <span className='limit-payouts-column name'>{t(name)}</span>
              <div className='limit-payouts-column-container'>
                <div className='results-fairness-check-column'>
                  {card.map((item, index) => (
                    <div
                      key={item.concat(`${index}`)}
                      className={`results-fairness-check-cards ${colorClass[index]}`}
                    >
                      <span>{item}</span>
                      <i className={cardIcons[index]} />
                    </div>
                  ))}
                </div>

                <span className='limit-payouts-column coefficient'>{odd}</span>
              </div>
            </div>
          )
        )}
      </div>
    </div>
  );
});
export default LimitAndPayouts;
